<template>
  <div>
    <div class="i-layout-page-header">
      <div class="i-layout-page-header">
        <span class="ivu-page-header-title">{{ $route.meta.title }}</span>
      </div>
    </div>
    <Card :bordered="false" dis-hover class="ivu-mt">
      <Form ref="filter" :model="filter" :label-width="100" label-position="right" @submit.native.prevent>
        <Row type="flex">
          <Col v-bind="grid">
            <FormItem label="搜索内容：" label-for="key">
              <Input search enter-button placeholder="请输入耳标编号搜索" clearable v-model="filter.search"
                     @on-search="search" @on-clear="searchClear">
              </Input>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只类别：" label-for="key">
              <Select v-model="filter.pig_type_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigTypeList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="猪只品种：" label-for="key">
              <Select v-model="filter.pig_variety_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigVarietyList" :value="key" :key="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="筛选圈舍：">
              <Select v-model="filter.pig_house_id" class="perW100" @on-change="select">
                <Option :value="0">全部</Option>
                <Option v-for="(item, key) in pigHouseList" :key="key" :value="key">{{ item }}</Option>
              </Select>
            </FormItem>
          </Col>
          <Col v-bind="grid">
            <FormItem label="佩戴时间：" prop="key" label-for="key">
              <DatePicker type="daterange" :value="filter.ctime" confirm placeholder="请选择查询时间段"
                          style="width: 100%" @on-ok="dateOk" @on-change="dateChange"
                          @on-clear="dateClear"></DatePicker>
            </FormItem>
          </Col>
        </Row>

      </Form>

      <Table :columns="columns" stripe :data="tableData" ref="table" class="ivu-mt"
             :loading="loading"
             no-userFrom-text="暂无数据"
             no-filtered-userFrom-text="暂无筛选结果"
      >

      </Table>
      <Page :total="tableCount" :current="filter.page" :page-size="filter.limit" class="acea-row row-right page"
            show-total @on-change="changePage"></Page>
    </Card>
  </div>
</template>

<script>
import {pigInfoListApi} from '@/api/pigFarm/pigInfo'
import {pigTypeAllApi} from '@/api/pigFarm/pigType'
import {pigVarietyAllApi} from '@/api/pigFarm/pigVariety'
import {pigHouseAllApi} from "@/api/pigFarm/pigHouse";

export default {
  name: 'pigWearTagList',
  inject: ['reload'],
  data() {
    return {
      grid: {
        xs: 24,
        sm: 24,
        md: 12,
        lg: 7,
        xl: 7
      },
      filter: {
        page: 1,
        limit: 10,
        ctime: [],
        export: 0,
        search: '',
        gender: 0,
        pig_house_id: 0,
        pig_type_id: 0,
        pig_variety_id: 0,
      },
      pigHouseList: [],
      pigTypeList: [],
      pigVarietyList: [],
      tableData: [],
      tableCount: 0,
      loading: false,
      exportLoading: false,
      columns: [
        {
          title: '猪只类别',
          key: 'pig_type_name',
          minWidth: 100
        },
        {
          title: '猪只品种',
          key: 'pig_variety_name',
          minWidth: 100
        },
        {
          title: '所属圈舍',
          key: 'pig_house_name',
          minWidth: 100
        },
        {
          title: '耳标编号',
          key: 'tag_sn',
          minWidth: 180
        },
        {
          title: '佩戴时间',
          key: 'ctime',
          minWidth: 150
        },
        {
          title: '耳标状态',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              // 判断status = 0 返回 在线 其他返回 离线
              h('span', params.row.status === 0 ? '在线' : '离线')
            ])
          }
        },
      ]
    }
  },
  created() {
    this.loadTableData()
    this.loadPigTypeData()
    this.loadPigHouseData()
    this.loadPigVarietyData()
  },
  methods: {
    loadTableData() {
      this.loading = true
      this.filter.export = 0
      pigInfoListApi(this.filter).then(res => {
        this.tableData = res.data.list
        this.tableCount = res.data.count
        this.loading = false
      }).catch(res => {
        this.loading = false
        this.$Message.error(res.msg)
      })
    },
    // 猪类别
    loadPigTypeData() {
      pigTypeAllApi().then(res => {
        if (res.code === 200) {
          this.pigTypeList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 猪品种
    loadPigVarietyData() {
      pigVarietyAllApi().then(res => {
        if (res.code === 200) {
          this.pigVarietyList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error(res.msg)
      })
    },
    // 分页
    changePage(status) {
      this.filter.page = status
      this.loadTableData()
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.loadTableData()
    },
    // 搜索清空
    searchClear() {
      this.filter.search = ''
      this.loadTableData()
    },
    // 下拉选择
    select(value) {
      this.loadTableData()
    },
    // 选择时间
    dateOk() {
      this.loadTableData()
    },
    // 时间切换
    dateChange(dateArr) {
      this.filter.ctime = dateArr
    },
    // 时间清空
    dateClear() {
      this.filter.ctime = []
      this.loadTableData()
    },

    // 加载圈舍数据
    loadPigHouseData() {
      pigHouseAllApi().then(res => {
        if (res.code === 200) {
          this.pigHouseList = res.data
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(res => {
        this.$Message.error()
      })
    },

  }
}
</script>
